import { useMutation } from "@tanstack/react-query";
import {
  getShippingRates,
  type ShippingRatesPayload,
} from "../api/shippingService";
import { useAxiosInstance } from "./useAxiosInstance";

export const useShippingRates = () => {
  const axiosInstance = useAxiosInstance();

  return useMutation({
    mutationFn: (payload: ShippingRatesPayload) =>
      getShippingRates(axiosInstance, payload),
  });
};
